import React from 'react';

interface DonationsIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const DonationsIcon: React.FC<DonationsIconProps> = ({
  width = 29,
  height = 28,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M26.8041 8.9991C26.2164 9.11251 25.6597 9.28781 25.1133 9.47339C25.0308 10.4426 24.5874 11.4014 23.742 12.3706C20.4014 16.1545 15.6587 18.6702 12.4934 22.7325C11.3799 24.1244 10.7097 25.207 10.0189 26.9494C9.49308 28.2898 11.8542 27.733 12.1429 26.8154C12.4831 25.7122 12.7924 24.8461 13.9884 23.382C16.0814 20.8354 18.6796 19.1754 21.2469 17.0515C24.0513 14.7626 27.165 12.2262 27.1959 8.85474C27.0722 8.9166 26.9382 8.96817 26.8041 8.9991Z"
      fill={color}
    />
    <path
      d="M27.0209 4.91623C23.5773 5.59671 20.6079 7.55568 17.9685 9.76209C16.5972 10.9065 15.2259 12.0922 13.968 13.3604C13.401 13.9378 12.8339 14.5255 12.3287 15.1544C11.875 13.0511 11.0605 10.9787 9.70987 9.3394C8.5448 7.92688 6.19403 11.1643 7.18382 12.3706C8.75099 14.278 9.55521 16.8556 9.77173 19.2786C9.86452 20.3921 10.844 20.557 11.6379 19.8765C12.7823 18.897 13.5144 17.5464 14.5248 16.4329C15.6177 15.2163 16.8962 14.1749 18.1334 13.113C20.5357 11.0303 23.1442 9.16409 26.3301 8.53516C27.258 8.34958 27.9385 7.21547 28.1035 6.37002C28.2478 5.61736 27.9489 4.74096 27.0209 4.92655V4.91623Z"
      fill={color}
    />
    <path
      d="M8.20478 20.9489C7.10157 17.6599 5.1323 14.7833 3.50327 11.8139C2.72999 10.3807 2.02888 8.88578 1.9464 7.46295C1.7505 4.83382 4.38995 1.87475 7.17374 2.30778C8.50378 2.47275 9.66885 3.41098 10.339 4.55543L11.5659 6.73089C11.8959 7.37014 12.6382 8.21563 13.5146 7.93725C13.9786 7.7929 14.1435 7.62794 14.3497 7.48359C15.7932 6.31852 17.4222 5.22559 19.1543 4.74101C21.0308 4.11208 22.8558 4.35954 23.928 5.9164C24.6291 5.60709 25.3509 5.34934 26.0932 5.15345C24.557 2.24593 21.3917 1.41078 18.4635 3.00888C16.6489 3.88526 15.0715 5.14313 13.4218 6.05044C13.2465 5.65865 12.9784 4.94724 12.8856 4.69979C12.1124 2.33872 10.1328 0.37974 7.50368 0.0394992C2.07014 -0.5585 -1.59005 5.76176 0.688536 10.3086C2.86402 15.5772 6.59635 18.5259 7.02938 25.8978C7.08094 26.7948 7.93669 27.3 8.60686 27.3207C9.29766 27.3413 9.143 26.8257 9.15331 26.2483C9.17393 24.4234 8.8234 22.6192 8.23571 20.9489H8.20478Z"
      fill={color}
    />
  </svg>
);

export default DonationsIcon;
